import { endpoints } from "../../../configs/Settings";
import { useAxios } from "../../../utils/useAxios";
import { HTTPResponseStatus } from "../../../utils/enum";

import { useAuth } from "../../../utils/useAuth";
import { toast } from "react-toastify";

export async function DeleteQuestionnaireResponse(id: string) {
  const url = `${endpoints.ADMFHIR}/QuestionnaireResponse/${id}`;

  const bearerToken = await useAuth.getUserToken();

  const headers = {
    Accept: "*/*",
    Authorization: bearerToken,
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .delete(url, { headers, timeout: 8000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`DeleteQuestionnaireResponse: ${response.status}`);
      }
      return { status: HTTPResponseStatus.Success, data: response.data };
    })
    .catch((error) => {
      console.error("DeleteQuestionnaireResponse ", error);
      // toast.error(
      //   `DeleteQuestionnaireResponse Error: ${error?.response?.status}`
      // );
      throw new Error();
    });
  if (response) return response;
}
